import { ReactElement } from 'react';
import { useTheme } from 'styled-components';

import { DoDisturbAltIcon } from '@breathelife/mui';

import { SVGIconProps } from 'Components/Icon/IconMap';

import { SharedTheme } from '../../Theme';

export function DoDisturbAlt(props: SVGIconProps & { size?: string }): ReactElement {
  const theme = useTheme() as SharedTheme;

  return (
    <DoDisturbAltIcon
      style={{ color: props.color?.primary || theme.colors.icons.primary, fontSize: props.size || '16px' }}
    />
  );
}
